const STAGE_LABELS = {
    job_queued: 'Esperando procesamiento',
    processing_started: 'Preparando archivo',
    counting_rows: 'Contando registros',
    temporary_files_generating: 'Generando archivos temporales',
    chunk_processed: 'Generando archivos temporales',
    temporary_files_saved: 'Archivos temporales listos',
    temporary_tables_loaded: 'Datos cargados en tablas temporales',
    data_copied: 'Finalizando importación',
    processing_completed: 'Carga completada',
    processing_failed: 'Carga fallida',
};

export function stageLabel (item) {
    if (item.status === 'completed') return 'Carga completada';
    if (item.status === 'failed') return 'Carga fallida';
    if (item.status === 'cancelled') return 'Carga cancelada';
    return STAGE_LABELS[item.latestEvent] || (item.status === 'queued' ? 'Esperando procesamiento' : 'Preparando carga');
}

export function remainingTime (item, now = Date.now()) {
    if (item.status !== 'processing' || !item.startedAt) return null;
    const progress = Number(item.progress);
    const startedAt = new Date(item.startedAt).getTime();
    const lastUpdateAt = new Date(item.lastUpdateAt).getTime();
    const elapsed = (now - startedAt) / 1000;
    const lastUpdateAge = (now - lastUpdateAt) / 1000;
    if (!Number.isFinite(progress) || progress < 10 || progress >= 100 ||
        !Number.isFinite(elapsed) || elapsed < 10 ||
        !Number.isFinite(lastUpdateAge) || lastUpdateAge > 120) return null;

    // El primer 10% corresponde a la preparación y al conteo. Desde ese punto,
    // las filas procesadas permiten estimar la velocidad real de la carga.
    const processed = Number(item.processedRows);
    const total = Number(item.totalRows);
    let seconds;
    if (processed > 0 && total > processed && progress < 70) {
        const rowRate = processed / elapsed;
        const remainingRows = (total - processed) / rowRate;
        // El backend reserva otro 30% para cargar tablas y copiar datos.
        seconds = remainingRows + (total / rowRate) * (30 / 60);
    } else {
        seconds = elapsed * (100 - progress) / progress;
    }
    if (!Number.isFinite(seconds) || seconds < 0) return null;
    if (seconds > 86400) return 'más de 24 h';
    if (seconds < 60) return 'menos de 1 min';
    const minutes = Math.ceil(seconds / 60);
    if (minutes < 60) return `${minutes} min`;
    return `${Math.floor(minutes / 60)} h ${minutes % 60} min`;
}

export function remainingTimeStatus (item, now = Date.now()) {
    if (item.status === 'queued') return 'En cola';
    if (item.status !== 'processing') return '-';
    const lastUpdateAt = new Date(item.lastUpdateAt).getTime();
    if (Number.isFinite(lastUpdateAt) && now - lastUpdateAt > 120000) return 'Sin avance reciente';
    if (Number(item.progress) < 10) return 'Contando filas';
    return 'Estimando...';
}

export function updateAge (item, now = Date.now()) {
    if (!item.lastUpdateAt) return null;
    const seconds = Math.max(0, Math.floor((now - new Date(item.lastUpdateAt).getTime()) / 1000));
    if (!Number.isFinite(seconds)) return null;
    if (seconds < 60) return `hace ${seconds} s`;
    if (seconds < 3600) return `hace ${Math.floor(seconds / 60)} min`;
    return `hace ${Math.floor(seconds / 3600)} h`;
}
